
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class BaseButtonIcon extends Vue {
    @Prop({ type: Boolean, default: false })
    readonly disabled!: boolean;

    @Prop({ type: String, default: '' })
    readonly label!: string;

    @Prop({ type: String, default: 'bottom' })
    readonly labelPlacement!: string;

    @Prop({ type: String, default: 'full' })
    readonly rounded!: string;

    @Prop({ type: String, default: 'md' })
    readonly size!: string;

    @Prop({ type: String, default: 'button' })
    readonly type!: string;

    get computedClass() {
        return [
            'focus:outline-none',
            ['rounded', this.rounded].filter((item) => !!item).join('-'),
            {
                'p-1': this.size === 'sm',
                'p-2': this.size === 'md',
                'cursor-not-allowed': this.disabled,
            },
        ];
    }
}
